import React from 'react';
import { Alert } from 'react-bootstrap';

import {
  CreateUpdatePurchaseInvoiceEstimateItemDto,
  GetPurchaseInvoiceExtendedDto,
} from '../../../common/pokCore/autogenerated/pokApiClient';
import { useTranslation } from '../../../common/hooks/useTranslation';
import mathUtils from '../../../utils/mathUtils';
import { PurchaseInvoiceStatusEnum } from '../../../common/pokCore/validation/enums';

interface AlertNoProjectsInEstimateItemsProps {
  extendedPurchaseInvoice?: GetPurchaseInvoiceExtendedDto;
  purchaseInvoiceEstimateItems?: CreateUpdatePurchaseInvoiceEstimateItemDto[];
}

export const AlertNoProjectsInEstimateItems: React.FC<
  AlertNoProjectsInEstimateItemsProps
> = ({ extendedPurchaseInvoice, purchaseInvoiceEstimateItems }) => {
  const { t, tk } = useTranslation('fvzLng');

  const shouldShowAlert =
    extendedPurchaseInvoice?.status === PurchaseInvoiceStatusEnum.Open &&
    purchaseInvoiceEstimateItems
      ? mathUtils
          .Big(extendedPurchaseInvoice?.amount)
          .minus(
            purchaseInvoiceEstimateItems.reduce(
              (sum, item) => mathUtils.add(sum, item.amount),
              0,
            ),
          )
          .eq(0) &&
        extendedPurchaseInvoice?.projectIds?.some(
          projectId =>
            purchaseInvoiceEstimateItems?.filter(
              o => !mathUtils.Big(o.amount).eq(0) && o.projectId === projectId,
            ).length === 0,
        )
      : mathUtils.Big(extendedPurchaseInvoice?.amountWithoutPosition).eq(0) &&
        extendedPurchaseInvoice?.projectIds?.some(
          projectId =>
            extendedPurchaseInvoice?.purchaseInvoiceEstimateItems?.filter(
              o => o.estimateItem?.estimateByMonth?.project?.id === projectId,
            ).length === 0,
        );

  if (!shouldShowAlert) {
    return null;
  }

  const isZeroInvoice = mathUtils
    .Big(extendedPurchaseInvoice?.amount ?? 0)
    .eq(0);

  if (isZeroInvoice) {
    return (
      <Alert variant="info">{t(tk.prLang.zeroInvoiceProjectsWillBeKept)}</Alert>
    );
  }

  return (
    <Alert variant="warning">{t(tk.prLang.noProjectInEstimateItems)}</Alert>
  );
};
